import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { selectShowDataScience } from 'store/global'
import { getVerticalIdFromPath } from 'config/verticalRoutes'
import { useEnabledVerticalIds } from 'services/verticalsQueryService'

const isDataSciencePath = (pathname: string): boolean =>
  pathname === '/data-science' || pathname.startsWith('/vertical/data-science/')

/**
 * @description Hook to check if the current path/vertical is accessible to the user.
 * IMPORTANT: This hook ONLY checks if a vertical is enabled via the `isEnabled` flag.
 * Each page is in-charge of its own state (missing data,indices, etc...)
 *
 */
export const useVerticalAccess = (): {
  isLoading: boolean
  isCurrentPathEnabled: boolean
} => {
  const { pathname } = useLocation()
  const { enabledVerticalIds, isLoading } = useEnabledVerticalIds()
  const showDataScience = useSelector(selectShowDataScience)

  // Special case: Data Science is controlled by the environment flag, not database
  if (showDataScience && isDataSciencePath(pathname)) {
    return { isCurrentPathEnabled: showDataScience, isLoading: false }
  }

  const verticalId = getVerticalIdFromPath(pathname)

  // Non-vertical paths (dashboard, management, businesses, etc.) are always accessible
  if (!verticalId) {
    return { isCurrentPathEnabled: true, isLoading: false }
  }
  return { isCurrentPathEnabled: enabledVerticalIds.includes(verticalId), isLoading }
}
